import React, {useRef, useState} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {Box, FormControl, TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import {InstagramEmbed} from "react-social-media-embed";
import {Helmet} from "react-helmet";
import {Crumbs} from "./Crumbs.jsx";

const API = process.env.REACT_APP_BACKEND_HOST;

const StatusBar = ({status, response}) => {
    let component;
    switch(status) {
        case "idle": 
            component = <span />
            break;
        case "pending": 
            component = <Alert variant={"filled"} icon={false} severity={"info"}>Sending Email</Alert>;
            break;
        case "fail": 
            component = <Alert variant={"filled"} icon={false} severity={"error"}>Email failed to send. {response}</Alert>;
            break;
        case "success": 
        default:
            component = <Alert variant={"filled"} icon={false}>Email sent</Alert>;
            break;
    }
    return component;
}

const title = "Contact Austin 2 Step"
const desc = "Have feedback? Need something listed? Need more information? Please feel free to reach out via Email or Instagram"

const Contact = () => {

    let [status, setStatus] = useState("idle")
    let [response, setResponse] = useState("")

    const name = useRef("");
    const email = useRef("");
    const subject = useRef("");
    const message = useRef("");

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus("pending");
        fetch(API + "/contact/send", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name.current.value,
                email: email.current.value,
                subject: subject.current.value,
                message: message.current.value
            })
        })
            .then(async(res) => {
                switch (res.status) { 
                    case 400:
                    case 500:
                        const body = await res.json()
                        setStatus("fail")
                        setResponse(body.error.message)
                        return 
                    case 200:
                        setStatus("success")
                        name.current.value = "";
                        email.current.value = "";
                        subject.current.value = "";
                        message.current.value = "";
                        return
                }
                
            })
            .catch(e => setStatus("fail"))
    }



    return <Grid container spacing={2}>
        <Helmet>
            <meta charSet="utf-8"/>
            <meta property="og:description" content={desc}/>
            <meta property="twitter:title" content={title}/>
            <meta property="twitter:description" content={desc}/>
            <title>{title}</title>
            <meta property="description" content={desc} />
            <link rel="canonical" href="https://austin2step.com/contact"/>
        </Helmet>
        <Grid item xs={12}>
            <Crumbs crumbs={
                [
                    {title: "This Site"},
                    {title: "Contact"}
                ]} />
        </Grid>
        <Grid item xs={12}>
            <StatusBar status={status} response={response} />
        </Grid>
        <Grid item xs={12}>
            <Typography variant={"h4"}>{title}</Typography>
            <Typography variant={"body2"}>{desc}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Box component={"form"} sx={{ '& .MuiTextField-root': { m: 1, width: '50ch' } }}>
                        <Typography variant={"h6"}>Email</Typography>
                        <FormControl>
                            <div>
                                <TextField label={"Your name"} autoComplete={"name"} variant={"filled"} inputRef={name} type={"name"} required />
                            </div>
                            <div>
                                <TextField label={"Email"} autoComplete={"email"} variant={"filled"} inputRef={email} type={"email"} required />
                            </div>
                            <div>
                                <TextField label={"Subject"} variant={"filled"} inputRef={subject} required />
                            </div>
                            <div>
                                <TextField label={"What's on your mind?"} variant={"filled"} inputRef={message} multiline rows={8} required />
                            </div>
                            <div>
                                <Button variant={"contained"} onClick={sendEmail} disabled={status === "pending"}>Submit</Button>
                            </div>
                        </FormControl>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Typography variant={"h6"}>Instagram</Typography>
                    <InstagramEmbed url={"https://instagram.com/austin2step"} />
                </CardContent>
            </Card>
        </Grid>
    </Grid>
}

export default Contact